import urlConfig from "../../config.json";
import { BACKEND_URL } from "../../constants";
import { axios } from "../../utils/axiosConfig";

export const assignPropertyCompany = async (reqData) => {
  const ROUTE = urlConfig.backend.routes.properties.assignPropertyCompany;
  const url = `${BACKEND_URL}${ROUTE}`;

  return await axios
    .post(url, reqData)
    .then((res) => {
      if (res.status === 200) {
        return { res: res.data, error_code: 1 };
      } else {
        return {
          error_code: 2,
          error_message: "Something Went Wrong please try again later",
        };
      }
    })
    .catch((error) => {
      if (error.response.status === 400) {
        return {
          error_code: 3,
          error_message: "Something Went Wrong please try again later",
        };
      } else {
        alert(error.response.data.message);
      }
    });
};
